<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" :rules="rules" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="品种规格" prop="specId">
              <el-input v-model="specName" placeholder="请选择" :readonly="true" @click.native="onSpecShow(formData, onFormDataSpecChange)" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="配方" prop="productName">
              <el-input v-model="formData.productName" placeholder="请输入配方" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品编号" prop="productCode">
              <el-input v-model="formData.productCode" placeholder="请输入产品编号" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="productType" label="产品类型">
              <el-select :disabled="true" v-model="formData.productType" placeholder="请选择产品类型" clearable>
                <el-option v-for="(item, index) of Array.from(productTypeMap)" :key="index" :label="item[1]"
                  :value="item[0]"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附件">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="forList" label="产品配方">
              <el-button size="mini" type="text" icon="el-icon-plus" @click="addForList">添加</el-button>
              <el-table size="mini" stripe border :data="formData.forList">
                <el-table-column prop="specId" label="品种规格">
                  <template v-slot="{ row }">
                    <el-input readonly v-model="row.specName" @click.native="onSpecShow(row, onForListSpecChange)" placeholder="请选择品种规格" />
                  </template>
                </el-table-column>
                <el-table-column prop="unit" label="单位"></el-table-column>
                <el-table-column prop="consumeQuantity" label="消耗数量">
                  <template v-slot="{ row, $index }">
                    <el-form-item :prop="`forList.${$index}.consumeQuantity`" :rules="[{ required: true, message: '请输入消耗数量' }]">
                      <el-input v-model="row.consumeQuantity" placeholder="请输入消耗数量" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template v-slot="{ $index }">
                    <el-button readonly type="text" class="del-btn" @click="deleteRow($index, formData.forList)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="outList" label="产品产出">
              <el-button size="mini" type="text" icon="el-icon-plus" @click="addOutList">添加</el-button>
              <el-table size="mini" stripe border :data="formData.outList">
                <el-table-column prop="specId" label="品种规格">
                  <template v-slot="{ row }">
                    <el-input readonly v-model="row.specName" @click.native="onSpecShow(row, onForListSpecChange)" placeholder="请选择品种规格" />
                  </template>
                </el-table-column>
                <el-table-column prop="unit" label="单位"></el-table-column>
                <el-table-column prop="outputQuantity" label="产出数量">
                  <template v-slot="{ row, $index }">
                    <el-form-item :prop="`outList.${$index}.outputQuantity`" :rules="[{ required: true, message: '请输入产出数量' }]">
                      <el-input v-model="row.outputQuantity" placeholder="请输入产出数量" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template v-slot="{ $index }">
                    <el-button type="text" class="del-btn" @click="deleteRow($index, formData.outList)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
    <SpecChoose :visible.sync="dialogVisible" @select="onSpecSelect"></SpecChoose>
  </div>
</template>

<script>
import { managerType, productType } from '@/utils/dict'
import SpecChoose from '@/components/SpecChoose.vue'
export default {
  name: 'ProductManageAdd',
  components: { SpecChoose },
  data() {
    return {
      dialogVisible: false,
      userList: [],
      areaList: [],
      managerTypeMap: managerType,
      productTypeMap: productType,
      specName: '', // 品种规格名称
      formData: {
        specId: '', // 规格id
        productName: '', // 配方
        productCode: '', // 产品编号
        productType: '', // 产品类型 1精炼车间 2包装车间
        fileList: [], // 附件列表
        forList: [], // 产品配方列表
        outList: [] // 产品产出
      },
      rules: {
        specId: [{ required: true, message: '请选择品种规格' }],
        productName: [{ required: true, message: '请输入配方' }],
        forList: [{ required: true, type: 'array', message: '请添加产品配方' }],
        outList: [{ required: true, type: 'array', message: '请添加产品产出' }]
      },
      currentRow: {},
      callback: null
    }
  },
  computed: {
    productId() {
      return this.$route.query.productId
    },
    productType() {
      return this.$route.query.productType
    }
  },
  created() {
    this.loadUserList()
    this.loadAreaList()
    this.formData.productType = this.productType
    if (this.productId) {
      this.loadDetails()
    }
  },
  methods: {
    deleteRow(index, row) {
      row.splice(index, 1)
    },
    onSpecShow(row, callback) {
      this.dialogVisible = true
      this.currentRow = row
      console.log('onSpecShow ', this.currentRow, row, callback)
      this.callback = callback
    },
    onSpecSelect(data) {
      this.callback(this.currentRow, data)
    },
    onFormDataSpecChange(row, data) {
      this.specName = data.specName
      row.specId = data.specId
    },
    onForListSpecChange(row, data) {
      console.log('datadata', data)
      row.specName = data.specName
      row.specId = data.specId
      row.unit = data.unit
    },
    addForList() {
      this.formData.forList.push({
        specId: '', // 规格id
        specName: '',
        unit: '',
        consumeQuantity: '' // 消耗数量
      })
    },
    addOutList() {
      this.formData.outList.push({
        specId: '', // 规格id
        specName: '',
        unit: '',
        outputQuantity: '' // 产出数量
      })
    },
    loadAreaList() {
      this.$axios.get(this.$apis.wspb.selectPaFactoryAreaByPage).then(res => {
        this.areaList = res.list
      })
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '1',
        page: 1,
        size: 999
      }).then(res => {
        this.userList = res.list
      })
    },
    loadDetails() {
      this.$axios.get(this.$apis.prodManage.selectScProductByProductId, {
        params: { productId: this.productId }
      }).then(res => {
        this.specName = res.specName
        this.formData = res
      })
    },
    submit() {
      this.$refs.formData.validate().then(() => {
        let url = this.$apis.prodManage.insertScProduct
        if (this.productId) {
          url = this.$apis.prodManage.updateScProduct
        }
        this.$axios.post(url, this.formData).then(res => {
          // this.$store.dispatch('getUserList')
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 95%;
}

.flex-end {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.table-form {

  .el-select,
  .el-input,
  .el-cascader,
  .el-input-number {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    display: none;

    &::before {
      display: none;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
</style>
